export class QuickBuyMediaCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return ['slides', 'slide', 'previous', 'next']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawer) {
      const onDrawersOpen = event => {
        if (event.detail.key !== this.drawer.key) return

        const images = this.drawer.querySelectorAll('img')
        images.forEach(image => {
          image.loading = 'auto'
        })

        window.BAO.eventBus.removeEventListener(
          window.BAO.EVENTS.DRAWERS.OPEN,
          onDrawersOpen,
        )
      }

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.DRAWERS.OPEN,
        onDrawersOpen,
      )
    }
  }

  initialiseCarousel () {
    super.initialiseCarousel()

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 800,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }

  get drawer () {
    return this.closest('site-drawer')
  }
}

if (!customElements.get('quick-buy-media-carousel')) {
  customElements.define('quick-buy-media-carousel', QuickBuyMediaCarousel)
}
